import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { Spinner, EmptyState } from '../../components/UI';
import { SectionIcon } from '../../components/StudentUI';
import { fmtDate } from '../../utils/format';

const ReadOnlyNote = ({ children }) => (
  <div className="stu-readonly-note">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" />
    </svg>
    {children}
  </div>
);

export default function StudentActivitiesPage() {
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api.get('/me/activities').then(res => { if (!cancelled) setLogs(res.data.data || []); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  if (loading) return <div className="stu-page"><Spinner /></div>;

  return (
    <>
      <div className="stu-topbar">
        <div className="stu-topbar-title">My Activities</div>
        <div className="stu-topbar-sub">Programme activity log</div>
      </div>
      <div className="stu-page">
        <ReadOnlyNote>Notes logged by admin during your programme.</ReadOnlyNote>

        <div className="stu-card">
          <div className="stu-card-head"><h3 className="d-flex align-items-center"><SectionIcon icon="bi-activity" color="var(--sms-stat-cyan)" />Activity log</h3></div>
          <div className="stu-card-body">
            {logs.length === 0 ? (
              <EmptyState icon="bi-activity" message="No activities logged yet" />
            ) : logs.map(l => (
              <div className="stu-activity" key={l.id}>
                <div className="stu-activity-date">{fmtDate(l.log_date)}</div>
                <div>
                  <div className="stu-activity-cat">{l.category}</div>
                  <div className="stu-activity-desc">{l.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
